"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLiveTag = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _css = _interopRequireDefault(require("@styled-system/css"));

var _Icon = require("../Icon");

var _Icons = require("../Icons");

var _Layout = require("../Layout");

function blinkingEffect() {
  return (0, _styledComponents.keyframes)(["50%{opacity:0;}"]);
}

var StyledDomestikaLiveTagContainer = (0, _styledComponents.default)(_Layout.Flex).withConfig({
  displayName: "DomestikaLiveTag__StyledDomestikaLiveTagContainer",
  componentId: "sc-6x29st-0"
})((0, _css.default)({
  'align-items': 'center',
  height: '18px'
}));
var StyledDomestikaLiveTag = (0, _styledComponents.default)(StyledDomestikaLiveTagContainer).withConfig({
  displayName: "DomestikaLiveTag__StyledDomestikaLiveTag",
  componentId: "sc-6x29st-1"
})(["&::after{display:block;position:relative;left:4px;width:4px;height:4px;background:#FFFFFF;animation:", " 1s steps(1,end) infinite;content:'';border-radius:100%;}"], blinkingEffect);

var DomestikaLiveTag = function DomestikaLiveTag() {
  return _react.default.createElement(StyledDomestikaLiveTag, {
    backgroundColor: "rambutan",
    paddingRight: 3,
    paddingLeft: 2,
    borderRadius: 1
  }, _react.default.createElement(_Icon.Icon, {
    size: "medium",
    color: "coco"
  }, _react.default.createElement(_Icons.Live, null)));
};

exports.DomestikaLiveTag = DomestikaLiveTag;